/* eslint-disable @typescript-eslint/no-explicit-any */
import { FilterSettingsModel, IFilter, PageSettingsModel } from '@syncfusion/ej2-react-grids';

export const getSettingsView = (navData) => {

  const pageSettingsInfinite: PageSettingsModel = {
    pageSize: 100
  };
  const filterMenu: IFilter = {
    type: 'CheckBox',
    operator: 'contains'
  };
  const pageSettings: PageSettingsModel = {
    pageSize: navData?.widgetData?.pageSize ?? '20',
    pageSizes: ['5', '10', '20', '50']
  };
  const customAttributes: any = { class: 'customcss' };
  const selectionSettings: any = {
    mode: 'Row',
  };
  const filterSettingsMenu: FilterSettingsModel = {
    showFilterBarOperator: true,
    mode: 'Immediate',
    immediateModeDelay: 400
  };


  return {
    pageSettingsInfinite,
    filterMenu,
    pageSettings,
    customAttributes,
    selectionSettings,
    filterSettingsMenu
  };
};